module.exports = __webpack_public_path__ + "static/media/BrokenLink.51837b6c.svg";